import React from 'react';
import {validatable} from 'components/utils';
import DataSelected from './DataSelected.jsx';
import ItemChildren from './ItemChildren.jsx';
import ItemParents from './ItemParents.jsx';
import ShowIf from './ShowIf.jsx';
require('./_Style.scss');
class ReactTreeSelectOneElement extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data,
      value: this.props.value,
      optionOpened: false,
      propertyChildren: this.props.propertyChildren,
      propertyParent: this.props.propertyParent,
      selectAllChildren: false
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      value: nextProps.value,
      propertyChildren: nextProps.propertyChildren,
      propertyParent: nextProps.propertyParent,
    });
  }

  getParents(data) {
    let DataFillter = [...data];

    let DataParents = [];

    DataFillter.map((state, i) => {
      let draf = [...data];
      if (state[this.state.propertyChildren] != null) {
        let dataCheck = draf.filter(item => {
          return item[this.state.propertyParent] == state[this.state.propertyChildren][this.state.propertyParent]
        })
        if (dataCheck.length > 0) {
          // Do nothing
        } else {
          DataParents[DataParents.length] = DataFillter[i];
        }
      } else {
        DataParents[DataParents.length] = DataFillter[i];
      }
    })


    let dataRender = DataParents.map((item, i) => {
      return (
        <ItemParents key={i} only={true} label={item.ten} itemSelected={this.state.value} value={item[this.state.propertyParent]} selectedOption={this.selectedOption.bind(this)}>
          {
            this.getChildren(item[this.state.propertyParent], data)
          }
        </ItemParents>
      )
    });

    return dataRender;
  }

  getChildren(id, data) {
    let DataFillter = [...data];

    let DataChildren = DataFillter.filter(state => {
      return state[this.state.propertyChildren] && state[this.state.propertyChildren][this.state.propertyParent] == id
    });

    let dataRender = ('')
    if (DataChildren.length > 0) {
      dataRender =  DataChildren.map((item, i) => {
        return (
          <ItemChildren key={i} only={true} label={item.ten} itemSelected={this.state.value} value={item[this.state.propertyParent]} selectedOption={this.selectedOption.bind(this)}>
            {
              this.getChildren(item[this.state.propertyParent], data)
            }
          </ItemChildren>
        )
      });
    }

    return dataRender;
  }

  selectedOption(e) {
    let value = e;
    this.setState({
      value: value
    },()=> {
      this.props.onChange(e);
      this.toggleOption(this)
    })
  }

  toggleOption(e) {
    if (!this.state.optionOpened) {
      document.addEventListener('click', this.handleOutsideClick.bind(this), false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick.bind(this), false);
    }

    this.setState({
      optionOpened: !this.state.optionOpened
    })
  }

  closeOption(){
    this.setState({
      optionOpened: false
    })
  }

  handleOutsideClick(e) {
    if (this.node && this.node.contains(e.target)) {
      return;
    } else if (this.node && !this.node.contains(e.target)){
      this.closeOption();
    }
  }

  clearData() {
    this.setState({
      value: null
    },()=> {
      this.props.onChange(this.state.value);
      this.toggleOption(this)
    })
  }

  render() {
    let dataRender = this.getParents(this.state.data);
    return (
      <section className={this.state.optionOpened ? 'rs-wrapper rs-one-element open' : 'rs-wrapper rs-one-element'} id='node' ref={node => { this.node = node; }}>
        <DataSelected name={this.props.name} toggleOption={this.toggleOption.bind(this)} dataOptions={this.state.data} keyName={this.state.propertyParent} only={true} value={this.state.value}/>
        <ShowIf condition={!this.state.value || this.state.value === null}>
          <span className='rs-place-holder'>{this.props.placeholder}</span>
        </ShowIf>
        <div className={this.state.optionOpened ? 'rs-wrap-options' : 'rs-wrap-options hidden'}>
          <div className='rs-children pl5'>
            <span className='rs-label' onClick={this.clearData.bind(this)}>{this.props.placeholder}</span>
          </div>
          {dataRender}
        </div>
      </section>
    )
  }
}

ReactTreeSelectOneElement.defaultProps = {
  data: [],
  value: [],
  selectAllChildren: false,
  placeholder: '--Chọn--',
  propertyChildren: '',
  propertyParent: '',
  name: ''
}


export default validatable(ReactTreeSelectOneElement);



// WEBPACK FOOTER //
// ./src/components/tt-forms/react-tree-select/ReactTreeSelectOneElement.jsx